import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import PageSectionsRenderer from "../../components/common/PageSectionsRenderer";
import { FaMapMarkedAlt, FaBullhorn, FaUsers, FaHandshake } from "react-icons/fa";

const ChaitanyaYatra = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Navbar />
      
      {/* Hero */}
      <section className="relative bg-blue-900 text-white py-24 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6">Para Sports Chaitanya Yatra</h1>
          <p className="text-xl md:text-2xl opacity-90">
            A historic statewide awareness movement empowering persons with disabilities through sports across all 26 districts of Andhra Pradesh.
          </p>
        </div>
      </section>

      {/* Objectives */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-10 text-center">Our Objectives</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: <FaBullhorn />, title: "Create Awareness", text: "Promoting para sports opportunities among differently-abled youth." },
              { icon: <FaUsers />, title: "Identify Talent", text: "Scouting new sporting talent from grassroots levels in rural and urban areas." },
              { icon: <FaHandshake />, title: "Educate Families", text: "Informing families and communities about sports-based empowerment." },
              { icon: <FaMapMarkedAlt />, title: "Spread Information", text: "Disseminating info on government support, policies, and career pathways." }
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="text-blue-600 text-4xl mb-4 flex justify-center">{item.icon}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Phases */}
      <section className="py-16 bg-white px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-12 text-center">Journey Across Andhra Pradesh</h2>
          <div className="space-y-12">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="md:w-1/2">
                <img src="/images/yatra-phase1.jpg" onError={(e) => e.target.src='/images/image-fallback.svg'} alt="Phase I" className="rounded-xl shadow-lg w-full" />
              </div>
              <div className="md:w-1/2">
                <h3 className="text-2xl font-bold text-blue-800 mb-4">Phase I: Uttarandhra Region</h3>
                <p className="text-slate-700 mb-4">
                  The Yatra began in the northern districts: <strong>Srikakulam, Vizianagaram, and Visakhapatnam</strong>.
                </p>
                <p className="text-slate-600">
                  Focused interaction programs were organized with local disabled associations, students, athletes, and public representatives to introduce Para sports at the grassroots level.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row-reverse gap-8 items-center">
              <div className="md:w-1/2">
                <img src="/images/yatra-phase2.jpg" onError={(e) => e.target.src='/images/image-fallback.svg'} alt="Phase II" className="rounded-xl shadow-lg w-full" />
              </div>
              <div className="md:w-1/2">
                <h3 className="text-2xl font-bold text-blue-800 mb-4">Phase II: Godavari & Central Coastal</h3>
                <p className="text-slate-700 mb-4">
                  Expanded into: <strong>Kakinada, Rajahmundry, Amalapuram, Bhimavaram, Eluru, Vijayawada</strong>.
                </p>
                <p className="text-slate-600">
                  Awareness meetings were held in town halls and educational campuses. District sports officers and local MLAs actively participated.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="md:w-1/2">
                <img src="/images/yatra-phase3.jpg" onError={(e) => e.target.src='/images/image-fallback.svg'} alt="Phase III" className="rounded-xl shadow-lg w-full" />
              </div>
              <div className="md:w-1/2">
                <h3 className="text-2xl font-bold text-blue-800 mb-4">Phase III: South Coastal & Rayalaseema</h3>
                <p className="text-slate-700 mb-4">
                  Covering: <strong>Guntur, Ongole, Nellore, Tirupati, Kadapa, Ananthapur, Kurnool</strong> and surrounding regions.
                </p>
                <p className="text-slate-600">
                  Extensive outreach in district headquarters and community centers to reach aspiring Para athletes in the heart of Rayalaseema.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Stats */}
      <section className="py-16 bg-blue-600 text-white text-center px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-6">Impact of the Movement</h2>
          <p className="text-xl mb-8">
            "The Para Sports Chaitanya Yatra transformed the movement in Andhra Pradesh, resulting in historic participation and medal tallies."
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            <div className="p-4 border border-blue-400 rounded-lg">
              <div className="text-4xl font-bold mb-2">26</div>
              <div className="text-blue-200">Districts Covered</div>
            </div>
            <div className="p-4 border border-blue-400 rounded-lg">
              <div className="text-4xl font-bold mb-2">100s</div>
              <div className="text-blue-200">New Athletes Identified</div>
            </div>
            <div className="p-4 border border-blue-400 rounded-lg">
              <div className="text-4xl font-bold mb-2">67</div>
              <div className="text-blue-200">Medals at Jr. Nationals 2025</div>
            </div>
          </div>
        </div>
      </section>

      <PageSectionsRenderer pageKey="chaitanya_yatra" className="pt-0" />

      <Footer />
    </div>
  );
};

export default ChaitanyaYatra;

